import script from "./RedefinirSenha.vue?vue&type=script&setup=true&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&setup=true&lang=js"

import "./RedefinirSenha.vue?vue&type=style&index=0&id=8a475392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a475392"]])

export default __exports__